import { render, staticRenderFns } from "./BridgeItem.vue?vue&type=template&id=7c90a056&"
import script from "./BridgeItem.vue?vue&type=script&lang=js&"
export * from "./BridgeItem.vue?vue&type=script&lang=js&"
import style0 from "./BridgeItem.vue?vue&type=style&index=0&id=7c90a056&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports